module.exports = __webpack_public_path__ + "static/media/18_1.7d7a709a.jpg";